import React, { useState } from "react";
import styled from "styled-components";
import { Text } from "@mantine/core";
import {
  IconUserCheck,
  IconChartLine,
  IconTrendingUp,
  IconFileCheck,
} from "@tabler/icons-react";

const OuterContainer = styled.div`
  color: white;
  background-color: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 2rem;
`;

// Container for all cards
const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 2rem 5%;
  background-color: #000; /* Dark background */

  /* Media query for smaller screens */
  @media (max-width: 868px) {
    flex-direction: column;
    align-items: center;
  }
`;

// Individual Card styles
const Card = styled.div`
  background-color: transparent;
  border-radius: 15px;
  padding: 2rem;
  width: 23%;
  text-align: center;
  border: 1px solid rgb(167, 140, 76);
  transition: all 0.3s ease;

  &:hover {
    background-color: rgb(167, 140, 76);
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 868px) {
    width: 90%;
    margin-bottom: 1.5rem;
  }
`;

// Icon styles
const Icon = styled.div`
  color: rgb(167, 140, 76);
  margin-bottom: 1rem;
  transition: all 0.3s ease;

  ${Card}:hover & {
    color: white;
  }
`;

// Title styles
const Title = styled.h3`
  color: rgb(167, 140, 76);
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
  @media (min-width: 668px) {
    height: 5em;
  }
  @media (max-width: 1270px) and (min-width: 868px) {
    height: auto;
  }
  ${Card}:hover & {
    color: white;
  }
`;

// Description styles
const Description = styled.p`
  color: #666;
  font-size: 0.9rem;
  transition: all 0.3s ease;

  ${Card}:hover & {
    color: white;
  }
`;

const Whyus = () => {
  const [selectedCard, setSelectedCard] = useState(0); // State to track selected card

  // Function to handle card click
  const handleCardClick = (cardIndex) => {
    setSelectedCard(cardIndex);
  };

  return (
    <OuterContainer id="whyus">
      <Text
        weight={700}
        style={{
          fontSize: "3rem",
          fontWeight: "500",
          fontFamily: "Paris Avenue",
          marginTop: "1.5rem",
        }}
      >
        Why Us?
      </Text>

      <CardContainer>
        {/* Card 1 */}
        <Card highlight={selectedCard === 0} onClick={() => handleCardClick(0)}>
          <Icon highlight={selectedCard === 0}>
            <IconUserCheck style={{ width: "2.5rem", height: "2.5rem" }} />
          </Icon>
          <Title highlight={selectedCard === 0}>
            "Personalized Guidance for All Your Property Needs"
          </Title>
          <Description highlight={selectedCard === 0}>
            Offer personalized brokerage services that match each client's
            goals, whether they're buying, selling, or investing.
          </Description>
        </Card>

        {/* Card 2 */}
        <Card highlight={selectedCard === 1} onClick={() => handleCardClick(1)}>
          <Icon highlight={selectedCard === 1}>
            <IconChartLine style={{ width: "2.5rem", height: "2.5rem" }} />
          </Icon>
          <Title highlight={selectedCard === 1}>
            "Expert Advice for Informed Decisions"
          </Title>
          <Description highlight={selectedCard === 1}>
            Provide insights into property investments with an emphasis on
            making smart, strategic decisions.
          </Description>
        </Card>

        {/* Card 3 */}
        <Card highlight={selectedCard === 2} onClick={() => handleCardClick(2)}>
          <Icon highlight={selectedCard === 2}>
            <IconTrendingUp style={{ width: "2.5rem", height: "2.5rem" }} />
          </Icon>
          <Title highlight={selectedCard === 2}>
            "In-Depth Market Analysis for a Competitive Edge"
          </Title>
          <Description highlight={selectedCard === 2}>
            Utilize deep market knowledge and analysis to help clients
            capitalize on the best opportunities.
          </Description>
        </Card>

        {/* Card 4 */}
        <Card highlight={selectedCard === 3} onClick={() => handleCardClick(3)}>
          <Icon highlight={selectedCard === 3}>
            <IconFileCheck style={{ width: "2.5rem", height: "2.5rem" }} />
          </Icon>
          <Title highlight={selectedCard === 3}>
            "Seamless Legal and Documentation Support"
          </Title>
          <Description highlight={selectedCard === 3}>
            Ensure smooth and worry-free property deals with thorough legal and
            documentation assistance.
          </Description>
        </Card>
      </CardContainer>
    </OuterContainer>
  );
};

export default Whyus;

